import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import EEPROMGeneral from './eeprom.components/EEPROMGeneral';
import EEPROMOptionsMenu from './eeprom.components/EEPROMOptionsMenu';
import EEPROMUserMenu from './eeprom.components/EEPROMUserMenu';
import EEPROMOEMMenu from './eeprom.components/EEPROMOEMMenu';
import { MainRfContext } from '../context/MainRfContext';
import { MainContext } from '../context/MainContext';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

function ControlContent() {
  const state = useContext(MainRfContext);
  if ((state.selectedDevice === 0)) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
    <Stack sx={{ width: '100%' }} spacing={2}>
      <Alert variant="filled" severity="error">
        No spa associated with this account
      </Alert>
    </Stack>
  </Container>)
  } else if (!state.R2 || !state.RG) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Stack sx={{ width: '100%', pt: 2, pl: 3 }} spacing={2}>
        <Alert variant="filled" severity="error">
          No RF Data Available
        </Alert>
      </Stack>
    </Container>)
  } else {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <MainContext.Provider value={{ state }}>
          <Grid container spacing={3}>
            {/* Offline */}
            {state.online === false ? <Stack sx={{ width: '100%', pt: 2, pl: 3 }} spacing={2}>
                <Alert variant="filled" severity="error">
                  Spa is Offline
                </Alert>
              </Stack> : <div></div>}
            {/* General */} 
            <Grid item xs={20} md={8} lg={6}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <EEPROMGeneral />
              </Paper>
            </Grid>
            {/* Options Menu */} 
            <Grid item xs={20} md={8} lg={6}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <EEPROMOptionsMenu />
              </Paper>
            </Grid>
            {/* User Menu */} 
            <Grid item xs={20} md={16} lg={16}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <EEPROMUserMenu />
              </Paper>
            </Grid>
            {/* EEPROMOEMMenu */} 
            <Grid item xs={20} md={16} lg={16}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <EEPROMOEMMenu />
              </Paper>
            </Grid>
          </Grid>
        </MainContext.Provider>
        <Copyright sx={{ pt: 4 }} />
      </Container>
    );
  }
}

export default function Control() {
  return <ControlContent />;
}